import { Logger, prefix } from "../logging";

export type GDriveLogger = (id: string, message: string) => void;

export function idPrefix(logger: Logger, id: string): Logger {
  return prefix(logger, `[id=${id.substring(0, 8)}]`);
}
